import { useRef, useState } from 'react';
import { useFocusAtEnd } from '@client/new/shared/useFocusAtEnd';
import { MAX_POST_CHARS } from '../model/newPost.constants';

type Props = {
  initialText: string;
  onCancel: () => void;
  onSave: (text: string) => void;
};

export const EditContentForm = ({ initialText, onCancel, onSave }: Props) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [text, setText] = useState(initialText);
  const trimmed = text.trim();
  const overCap = trimmed.length > MAX_POST_CHARS;
  const canSave = trimmed.length > 0 && !overCap;

  useFocusAtEnd(inputRef);

  return (
    <div className="flex flex-col gap-4 rounded-[10px] border border-[#ECEDF2] bg-white p-4 focus-within:border-[#5F1ECC]">
      <textarea
        ref={inputRef}
        value={text}
        aria-label="Edit text"
        rows={1}
        onChange={(event) => setText(event.target.value)}
        className="block max-h-[120px] min-h-[48px] w-full resize-none overflow-y-auto bg-transparent text-[16px] leading-6 text-[#131313] outline-none [field-sizing:content]"
      />
      {overCap && (
        <span className="text-sm text-[#E5322D]">
          Text can be at most {MAX_POST_CHARS} characters
        </span>
      )}
      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-[10px] px-4 py-2 text-base font-medium text-[#646464]"
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={!canSave}
          onClick={() => onSave(trimmed)}
          className="rounded-[10px] bg-[#EDE5FC] px-4 py-2 text-base font-medium text-[#350584] disabled:bg-[#EEEEEE] disabled:text-[#9E9E9E]"
        >
          Save
        </button>
      </div>
    </div>
  );
};
